<template>
    <section>
        <component :is="pageCountry"></component>
    </section>
</template>
<script>
import CadastroTerritorio from './CadastroTerritorio.vue';
import CadastroTerritorioAr from './CadastroTerritorioAr.vue';
import CadastroTerritorioPY from './CadastroTerritorioPY.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CadastroTerritorioAr,
        CadastroTerritorio,
        CadastroTerritorioPY
    },
    computed: {
        ...mapState(['usuarioLogado']),

        pageCountry() {
            switch (this.usuarioLogado.ambienteLogado) {
                case 'AR':
                    return CadastroTerritorioAr;

                case 'PY':
                    return CadastroTerritorioPY;

                default:
                    return CadastroTerritorio;
            }
        }
    }
};
</script>
